<image-cropper
  [imageBase64]="imageData"
  format="png"
  [roundCropper]="true"
  [maintainAspectRatio]="true"
  [containWithinAspectRatio]="true"
  (imageCropped)="imageCropped($event)"
  output="base64"
></image-cropper>
